<template>
<div class="courseBg">
    <div class="indexBanner"><banner-tu></banner-tu></div>
    <div class="courseMain clearfix">
        <div class="courseContent" v-loading="loading">
            <h3 class="h3text" style="width:100%"><span>医师定期考核--业务地区</span></h3>
            <div class="courseMainList newCouseMain">
                <div class="courseColList" v-for="(item,index) in areaData" :key="index"  :title="item.BA_Title">
                    <router-link :to="{name:'areaCourseShow',params:{id:item.BA_AreaCode}}"><img :src="item.BA_ImgPath" class="image"></router-link>
                    <h4><router-link :to="{name:'areaCourseShow',params:{id:item.BA_AreaCode}}">{{item.AreaName}}</router-link></h4>
                    <div style="padding:5px 0px;" class="courseItemTitle">
                        <hr />
                        <h3><router-link :to="{name:'areaCourseShow',params:{id:item.BA_AreaCode}}">{{item.BA_Subtitle}}</router-link></h3>
                    </div>
                </div>
            </div>
            <el-button round  v-if="isVisableButton" @click="moreCourses">更多</el-button>
            <div v-if="isPaging" class="coursePage">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pageRows"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</div>


</template>

<script>
import Vue from 'vue'
import bannerTu from '@/components/main/banner.vue'
import coursePage from '@/components/course/coursePage.vue'

import api from "@/api/index.js";
import { setTimeout } from 'timers';
export default{
    created(){
        this.initList();
    },
    components:{
        bannerTu,
        coursePage
    },
    data(){
        return{
            loading: true,
            isPaging:false,
            isVisableButton:true,
            ProName:'',
            projiectType:'',
            paramsId:'',
            projectCodeArr:'',
            currentPage:1,
            pageRows:null,
            pageSize:8,
            areaData:[],
            staticData: [
              {
                "AreaName": "深圳市",
                "CreatorName": "医+E管理",
                "BA_ID": "0ff4f013-0b71-4625-a358-7c3542ee9a78",
                "BA_AreaCode": "e2e499fd-48eb-40df-ab76-ef3b19b14fa4",
                "BA_Title": "深圳市医师定期考核在线学习课程",
                "BA_Subtitle": "深圳市医师定期考核在线学习课程",
                "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/76311d12-e38d-4492-900e-bf56c1dabb53.jpg",
                "BA_StatusCode": 1001,
                "BA_Remark": "\r\n<div> <image  src=\"https://cdn.doc-exam.com/cms/1pluse/tupian.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -80px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
                "BA_CreateDate": "2020-09-16",
                "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
                "BA_UpateDate": "2026-01-06",
                "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
              },
              {
                "AreaName": "惠州市",
                "CreatorName": "医+E管理",
                "BA_ID": "55174c07-6775-411e-a8e5-c2740ae416c5",
                "BA_AreaCode": "87bb64be-a958-4605-a568-301c9fcc38e7",
                "BA_Title": "惠城、仲恺区医师定期考核在线学习",
                "BA_Subtitle": "惠城、仲恺区医师定期考核在线学习",
                "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/7fa5a65c-ee46-4ed1-829c-c2ec574f4cf1.jpg",
                "BA_StatusCode": 1001,
                "BA_Remark": "\r\n<div> <image  src=\"https://cdn.doc-exam.com/cms/1pluse/tupian.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -80px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
                "BA_CreateDate": "2019-10-15",
                "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
                "BA_UpateDate": "2026-01-08",
                "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
              },
              {
                "AreaName": "内蒙古自治区",
                "CreatorName": "医+E管理",
                "BA_ID": "8d476152-216b-4a60-8515-17adbf61fc6d",
                "BA_AreaCode": "c0364fe6-c329-4d44-9838-bc0568383418",
                "BA_Title": "内蒙古医师定期考核在线学习课程",
                "BA_Subtitle": "内蒙古医师定期考核在线学习课程",
                "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/5b0df7a1-fef4-40d8-9e80-47688dbe3add.jpg",
                "BA_StatusCode": 1001,
                "BA_Remark": "<div> <image src=\"https://cdn.doc-exam.com/cms/cnmia/Content/Upload/image/20231106/6383485918048460049221073.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -70px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
                "BA_CreateDate": "2019-10-15",
                "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
                "BA_UpateDate": "2026-01-06",
                "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
              },
              {
                "AreaName": "珠海市",
                "CreatorName": "医+E管理",
                "BA_ID": "91751d3b-5fa7-49b6-bb6f-101a8a2ce9e7",
                "BA_AreaCode": "8a10dba6-7805-4684-aa64-7084ba097fba",
                "BA_Title": "珠海市医师定期考核在线学习课程",
                "BA_Subtitle": "珠海市医师定期考核在线学习课程",
                "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/e16d2387-bc7c-4e35-8cb4-bedd84f9a980.jpg",
                "BA_StatusCode": 1001,
                "BA_Remark": "\r\n<div> <image  src=\"https://cdn.doc-exam.com/cms/1pluse/tupian.png\" /><br><br></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -58px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
                "BA_CreateDate": "2019-10-15",
                "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
                "BA_UpateDate": "2026-01-06",
                "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
              },
              {
                "AreaName": "东莞市",
                "CreatorName": "医+E管理",
                "BA_ID": "d2f9e081-c20a-4b75-88b6-8c6be27760e4",
                "BA_AreaCode": "125e8739-531a-4cfa-bba8-71fa0fffb0f3",
                "BA_Title": "东莞市医师定期考核在线学习课程",
                "BA_Subtitle": "东莞市医师定期考核在线学习课程",
                "BA_ImgPath": "https://cdn.doc-exam.com/Images/epluse-dk-area/367ca7a1-5021-4eaf-b04b-6c1ac81cf641.jpg",
                "BA_StatusCode": 1001,
                "BA_Remark": "<div> <image src=\"https://cdn.doc-exam.com/cms/cnmia/Content/Upload/image/20231106/6383485918048460049221073.png\" /></div>\r\n\r\n<style>\r\n.courseShowList {\r\n    margin: -70px auto;\r\n \r\n    border: 0 solid #000;\r\n    width: 60%;\r\n    text-align: left\r\n}\r\n</style>\r\n",
                "BA_CreateDate": "2019-10-15",
                "BA_Creator": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb",
                "BA_UpateDate": "2026-01-06",
                "BA_Modifier": "2a25ed5e-a6b7-4fb7-af05-0019d59190eb"
              }
            ]
        }
    },
    methods:{
        // 初始化加载课程列表
        initList(){
            this.areaData = this.staticData;
            this.pageRows = this.staticData.length;
            this.loading = false;
            console.log("课程列表:", this.areaData);
        },
        moreCourses(){
            this.isPaging=true;
            this.isVisableButton=false;
            this.pageSize=20;
            this.initList();
        },
        handleCurrentChange(val){
            this.currentPage=val;
            this.moreCourseList();
            setTimeout(function(){
                if(document.body.scrollTop){
                    document.body.scrollTop = 0
                }else {
                    document.documentElement.scrollTop = 0
                }
            },300)
        },
    },
}

</script>

<style>
.h3text{
    margin: 20px 0 15px 0;
    border: none;
    width: 100%;
    text-align: center;
    position: relative;
}
.h3text span{
     /* border-bottom: 2px solid blue;  */
}
.courseContent button{
    margin-left: 50%;
    margin-bottom: 15px;
}
.courseItemTitle{font-size: 14px;}
.newCouseMain .courseItemTitle h3{
    font-weight: normal;
    font-size: 16px;
    margin: 20px 0 10px 0;
    text-align: center;
}
.newCouseMain .courseItemTitle hr{border: 1px dashed lightgray;}
.newCouseMain .courseItemTitle p{ color: #999;}
.newCouseMain .courseItemTitle p span{ }
.newCouseMain .courseItemTitle p span.red{ color: red; font-size: 14px; font-weight: bold; }
.newCouseMain .courseItemTitle p span.green{ color: green; font-size: 14px; }
.newCouseMain .courseItemTitle p strong{ float:right; font-weight: normal; }
.newCouseMain .courseColList{ display: inline-block; border:1px solid transparent;    position: relative; margin: 0; padding:10px; width: 286px; box-sizing: border-box;}
.courseOn{position:absolute; top:125px; background-color: rgba(0,0,0,.5); width: 100%; color: #fff; font-size: 12px; line-height: 24px; padding-left: 5px; box-sizing: border-box; width: 274px;}
.courseOn span{ margin-right: 5px;}
.image {
    width: 100%;
    height: 140px;
    display: block;
  }
.newCouseMain .courseColList h4{
    font-size: 22px;
    text-align: center;
    margin:30px 0 20px 0;
}
.newCouseMain .courseColList h4 a{color: #0ba4ea;}

.newCouseMain .courseColList{
    webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border: 1px solid #eee;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);background-color: #fff;
    margin-right: 5px;
}
.newCouseMain .courseColList:hover{
    webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    border: 1px solid lightgray;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);background-color: #fff;
}

</style>
